export const CARD_TYPES = {
  PRICE: 'price',
  PROGRESS: 'progress',
  LEARNING: 'learning',
  UPCOMING: 'upcoming',
};

export const CARD_VARIANTS = {
  PROGRAM: 'program',
  COURSE: 'course',
}; 